var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileMap(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15515_2432)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50069 1.88771C1.80814 1.72949 2.17824 1.75637 2.4596 1.95734L8.41884 6.21394L15.2678 1.93335C15.4122 1.83975 15.5843 1.7854 15.7692 1.7854C15.9633 1.7854 16.1433 1.84526 16.2919 1.94753L22.7428 6.24813C22.9996 6.41933 23.1538 6.70754 23.1538 7.01618V22.0931C23.1538 22.4389 22.9606 22.7556 22.6532 22.9139C22.3457 23.0721 21.9756 23.0452 21.6942 22.8442L15.735 18.5876L8.88579 22.8684C8.74629 22.9588 8.58085 23.0125 8.4031 23.016C8.39751 23.0161 8.39192 23.0162 8.38634 23.0162C8.38052 23.0162 8.3747 23.0161 8.36889 23.016C8.18099 23.0129 8.00677 22.9536 7.86225 22.8543L1.41104 18.5534C1.15425 18.3822 1 18.094 1 17.7854V2.70848C1 2.36271 1.19324 2.04593 1.50069 1.88771ZM14.8462 4.37394L9.30769 7.83548V20.4276L14.8462 16.9661V4.37394ZM16.6923 17.0027V4.43327L21.3077 7.51019V20.2994L16.6923 17.0027ZM2.84615 4.50219L7.46154 7.7989V20.3683L2.84615 17.2914V4.50219Z",
    fill: "#FF5800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15515_2432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMap);
export default __webpack_public_path__ + "static/media/profile_map.a0773b1f940ef1d433c6fdebf4e16263.svg";
export { ForwardRef as ReactComponent };